module.exports = "https://p.cds.unp.clasificados.pe/cover.1c15d2e6c1a6a64d202c589fcbb8a07f.jpg";